var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1632 0.0800781C9.08832 0.0800781 0.0270996 9.06008 0.0270996 20.1201C0.0270996 30.1201 7.39689 38.4201 17.0219 39.9201V25.9201H11.9074V20.1201H17.0219V15.7001C17.0219 10.6801 20.0222 7.92008 24.6334 7.92008C26.8282 7.92008 29.1237 8.30008 29.1237 8.30008V13.2401H26.5866C24.0897 13.2401 23.3044 14.7801 23.3044 16.3601V20.1201H28.9022L27.9961 25.9201H23.3044V39.9201C28.0493 39.1758 32.37 36.7711 35.4865 33.1402C38.603 29.5093 40.31 24.8914 40.2992 20.1201C40.2992 9.06008 31.238 0.0800781 20.1632 0.0800781Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.3533103b42f1acee3cdb3dfe747f66e4.svg";
export { ForwardRef as ReactComponent };